// extracted by mini-css-extract-plugin
module.exports = {"marker":"VerseMarker_marker__EIAkL"};